import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/lib/utils'

type PasswordInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    // Layout classes such as margins go on the wrapper so the toggle stays centred.
    wrapperClassName?: string
}

// Password field, hidden by default, with a button to reveal what was typed.
export const PasswordInput = ({ className, wrapperClassName, ...props }: PasswordInputProps) => {
    const [isVisible, setIsVisible] = useState(false)

    return (
        <div className={cn('relative', wrapperClassName)}>
            <input
                {...props}
                type={isVisible ? 'text' : 'password'}
                // Edge draws its own reveal button; hide it to avoid two eyes.
                className={cn(className, 'pr-10 [&::-ms-reveal]:hidden')}
            />
            <button
                type="button"
                onClick={() => setIsVisible((visible) => !visible)}
                className="absolute inset-y-0 right-0 z-20 flex items-center px-3 text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:text-gray-700"
                aria-label={isVisible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                aria-pressed={isVisible}
            >
                {isVisible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
        </div>
    )
}
